import styled from "styled-components";

export const SubtitleText = styled.div.attrs(() => ({
  className: "mb-2 mt-3"
}))`
  &&& {
    font-size: 14px;
    color: ${props => props.theme["dark-grey"]};
  }
`;

export const StatusText = styled.span`
  margin-right: 8px;
  background-color: ${props => props.bgColor};
  color: ${props => props.color};
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: bold;
  font-size: 12px;
  display: inline-block;
  min-width: 80px;
  text-align: center;
`;

/**
 * Get eligibility status styles based on status value and theme
 * @param {string} status - The eligibility status ("Yes", "Submitted", "No")
 * @param {object} theme - The theme object containing eligibilityStatus styles
 * @returns {object} - Object with bgColor and color properties
 */
export const getEligibilityStatusStyles = (status, theme) => {
  switch (status) {
    case "Yes":
      return { bgColor: theme.eligibilityStatus.approved.background, color: theme.eligibilityStatus.approved.color };
    case "Submitted":
      return { bgColor: theme.eligibilityStatus.pending.background, color: theme.eligibilityStatus.pending.color };
    case "No":
      return { bgColor: theme.eligibilityStatus.denied.background, color: theme.eligibilityStatus.denied.color };
    default:
      return { bgColor: "transparent", color: "inherit" };
  }
};
